/*
 * Copyright (C) 2017 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'og-page-not-found',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss'],
  standalone: false
})
export class NoPermissionsComponent {}
